(function () {
  'use strict';
  if (window.__velInit) return; window.__velInit = true;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var TZ = 'Europe/Madrid';

  /* Aparición al hacer scroll */
  var revealEls = document.querySelectorAll('[data-reveal]');
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* Hora de España */
  function madridParts(date) {
    var parts = new Intl.DateTimeFormat('en-GB', { timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false, weekday: 'short' }).formatToParts(date);
    var o = {}; parts.forEach(function (p) { o[p.type] = p.value; });
    return { y: +o.year, m: +o.month, d: +o.day, h: +o.hour % 24, min: +o.minute, s: +o.second, wd: o.weekday };
  }

  /* Cuenta atrás hasta las 00:00 de España */
  var countdowns = document.querySelectorAll('[data-countdown]');
  if (countdowns.length) {
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var tick = function () {
      var p = madridParts(new Date());
      var left = 86400 - (p.h * 3600 + p.min * 60 + p.s);
      var txt = pad(Math.floor(left / 3600)) + ':' + pad(Math.floor(left % 3600 / 60)) + ':' + pad(left % 60);
      countdowns.forEach(function (el) { el.textContent = txt; });
    };
    tick(); setInterval(tick, 1000);
  }

  /* Fecha estimada de entrega (días laborables) */
  document.querySelectorAll('[data-delivery]').forEach(function (box) {
    var min = parseInt(box.dataset.min, 10) || 1, max = Math.max(parseInt(box.dataset.max, 10) || min, min);
    var cutoff = parseInt(box.dataset.cutoff, 10) || 14;
    var now = madridParts(new Date());
    var base = new Date(Date.UTC(now.y, now.m - 1, now.d, 12));
    var wd = base.getUTCDay();
    var late = wd !== 0 && wd !== 6 && now.h >= cutoff;
    var addBiz = function (n) {
      var d = new Date(base.getTime()); if (late) n += 1;
      while (n > 0) { d.setUTCDate(d.getUTCDate() + 1); var w = d.getUTCDay(); if (w !== 0 && w !== 6) n--; }
      return d;
    };
    var fmt = new Intl.DateTimeFormat('es-ES', { weekday: 'long', day: 'numeric', month: 'long', timeZone: 'UTC' });
    var el = box.querySelector('[data-delivery-text]');
    var when = late ? 'Si pides ahora' : 'Si pides hoy';
    var d1 = fmt.format(addBiz(min)), d2 = fmt.format(addBiz(max));
    el.innerHTML = (min === max) ? when + ', llega el <b>' + d1 + '</b>' : when + ', llega entre el <b>' + d1 + '</b> y el <b>' + d2 + '</b>';
  });

  /* Región de entrega */
  var regionSelects = document.querySelectorAll('[data-region-select]');
  var applyRegion = function (val) {
    regionSelects.forEach(function (s) { s.value = val; });
    var other = val === 'otras';
    document.querySelectorAll('[data-region-notice]').forEach(function (n) { n.hidden = !other; });
    document.querySelectorAll('[data-pay^="cod"]').forEach(function (b) { b.hidden = other; });
    document.querySelectorAll('[data-delivery]').forEach(function (b) { b.hidden = other; });
  };
  var savedRegion = 'peninsula';
  try { savedRegion = localStorage.getItem('vel-region') || 'peninsula'; } catch (e) {}
  applyRegion(savedRegion);
  regionSelects.forEach(function (s) {
    s.addEventListener('change', function () {
      try { localStorage.setItem('vel-region', s.value); } catch (e) {}
      applyRegion(s.value);
    });
  });

  /* Galería */
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var img = g.querySelector('.buybox__img');
    g.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        if (img) { img.style.opacity = 0; setTimeout(function () { img.removeAttribute('srcset'); img.src = t.dataset.src; img.style.opacity = 1; }, 180); }
        g.querySelectorAll('[data-thumb]').forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });
  });

  /* Selector de kits y pago */
  var stickyKit = document.querySelector('[data-sticky-kit]');
  var stickyPrice = document.querySelector('[data-sticky-price]');
  var stickyCompare = document.querySelector('[data-sticky-compare]');
  var isProductPage = /\/products\//.test(window.location.pathname);

  /* Abre el carrito lateral de Shrine con la respuesta de /cart/add.js */
  var openShrineDrawer = function (res) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') { window.location.href = root + 'cart'; return; }
    drawer.classList.remove('is-empty');
    try { drawer.renderContents(res); } catch (e) { window.location.href = root + 'cart'; }
  };
  var drawerSections = function () {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.getSectionsToRender !== 'function') return [];
    var out = [];
    drawer.getSectionsToRender().forEach(function (s) {
      [s.id, s.section].forEach(function (v) { if (v && out.indexOf(v) === -1) out.push(v); });
    });
    return out.slice(0, 5);
  };

  document.querySelectorAll('[data-buy-form]').forEach(function (form) {
    var idInput = form.querySelector('[data-variant-id]');
    var selName = form.querySelector('[data-selection]');
    var buttons = form.querySelectorAll('[data-pay]');
    var codLink = form.querySelector('[data-pay="cod-link"]');
    var paint = function (r, fromUser) {
      idInput.value = r.value;
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
      if (selName) selName.textContent = r.dataset.units + ' — ' + r.dataset.name;
      if (stickyKit) stickyKit.textContent = 'Kit · ' + r.dataset.units;
      if (stickyPrice) stickyPrice.textContent = r.dataset.price;
      if (stickyCompare) { stickyCompare.hidden = !r.dataset.compare; stickyCompare.textContent = 'Antes ' + r.dataset.compare; }
      buttons.forEach(function (b) { if (b.tagName === 'BUTTON') b.disabled = r.disabled; });
      if (codLink) codLink.href = codLink.dataset.productUrl + '?variant=' + r.value + '&cod=1#kits';
      /* EasySell lee la variante de la URL y del formulario de producto */
      if (isProductPage && fromUser) {
        try { var u = new URL(window.location.href); u.searchParams.set('variant', r.value); u.searchParams.delete('cod'); history.replaceState(history.state, '', u.toString()); } catch (e) {}
      }
    };
    form.querySelectorAll('[data-kit]').forEach(function (r) { r.addEventListener('change', function () { paint(r, true); }); });
    var checked = form.querySelector('[data-kit]:checked');
    if (isProductPage) {
      try {
        var v = new URL(window.location.href).searchParams.get('variant');
        var match = v && form.querySelector('[data-kit][value="' + v + '"]');
        if (match && !match.disabled) { match.checked = true; checked = match; }
      } catch (e) {}
    }
    if (checked) paint(checked, false);

    /* Pagar online: aplica el código, añade al carrito y abre el carrito lateral */
    form.addEventListener('submit', function (e) {
      if (!window.fetch || !window.FormData) return;
      e.preventDefault();
      var err = form.querySelector('[data-form-error]');
      if (err) err.hidden = true;
      var online = form.querySelector('[data-pay="online"]');
      if (online) online.setAttribute('aria-busy', 'true');
      var data = new FormData(form);
      data.delete('return_to');
      data.append('sections', drawerSections().join(','));
      data.append('sections_url', window.location.pathname);
      var code = (form.dataset.discount || '').trim();
      var applyCode = code ? fetch(root + 'discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).catch(function () {}) : Promise.resolve();
      applyCode
        .then(function () { return fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }, body: data }); })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (!res.ok || res.d.status) throw new Error(res.d.description || res.d.message || 'No se ha podido añadir el kit. Inténtalo de nuevo.');
          openShrineDrawer(res.d);
        })
        .catch(function (error) { if (err) { err.textContent = error.message; err.hidden = false; } })
        .finally(function () { if (online) online.removeAttribute('aria-busy'); });
    });
  });

  /* Si se llega a la ficha desde el botón de contra reembolso, abre el formulario de EasySell */
  try {
    if (isProductPage && new URL(window.location.href).searchParams.get('cod') === '1') {
      var tries = 0;
      var openCod = function () {
        var btn = document.querySelector('.es-popup-button-overwrite');
        tries++;
        if (btn && (window.EasySell || window.easysell || document.querySelector('[id*="es-"], [class*="es-form"], script[src*="easysell"], script[src*="tyslo"]'))) { btn.click(); return; }
        if (tries < 12) setTimeout(openCod, 500); else if (btn) btn.click();
      };
      window.addEventListener('load', function () { setTimeout(openCod, 800); });
    }
  } catch (e) {}

  /* vel-cod */ var clearDiscount = function () { document.cookie = 'discount_code=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT'; return fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: '' }) }).catch(function () {}); }; if (isProductPage && /discount_code=/.test(document.cookie)) clearDiscount(); document.addEventListener('pointerdown', function (e) { if (e.target.closest && e.target.closest('.vel [data-pay^="cod"]')) clearDiscount(); }, true); var velStyle = document.createElement('style'); velStyle.textContent = '.vel .pay #es-popup-button, .vel .pay .es-popup-button-product { display: none !important; } body:has(.vel-sec--buy-box) #es-sticky { display: none !important; }'; document.head.appendChild(velStyle); /* Barra fija de compra en móvil: siempre visible salvo cuando ya se ven los botones de pago */
  var sticky = document.querySelector('[data-sticky-buy]');
  var payZone = document.querySelector('.pay');
  if (sticky && payZone && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (en) { sticky.classList.toggle('is-hidden', en[0].isIntersecting); }, { threshold: 0.2 }).observe(payZone);
  }

  /* Ciclo: cada fase se ilumina al pasar por el centro de la pantalla */
  var cycleItems = document.querySelectorAll('[data-cycle] .cycle__item');
  if (cycleItems.length) {
    if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var cio = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-active'); cio.unobserve(en.target); } });
      }, { rootMargin: '-35% 0px -45% 0px' });
      cycleItems.forEach(function (el) { cio.observe(el); });
    } else { cycleItems.forEach(function (el) { el.classList.add('is-active'); }); }
  }

})();
